import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetCartById = async (cartId) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `
          query getCart($id: ID!) {
            cart(id: $id) {
              attributes {
                key
                value
              }
              checkoutUrl
              lines(first: 100) {
                edges {
                  node {
                    quantity
                    attributes {
                      key
                      value
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        title
                        image {
                          url
                        }
                        price {
                          amount
                        }
                        product {
                          id
                          title
                          productType
                          points: metafield(key: "patch_points", namespace: "my_fields") {
                            value
                          }
                          width: metafield(key: "patch_width", namespace: "my_fields") {
                            value
                          }
                          height: metafield(key: "patch_height", namespace: "my_fields") {
                            value
                          }
                          productPoints: metafield(key: "product_patch_points", namespace: "my_fields") {
                            value
                          }
                        }
                        points: metafield(key: "patch_points", namespace: "custom") {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables: { id: cartId },
      },
    });

    const cart = response.data?.data?.cart;
    if (!cart) return null;

    return {
      customAttributes: cart.attributes,
      webUrl: cart.checkoutUrl,
      lineItems: cart.lines.edges.map((e) => {
        const variant = e.node.merchandise;
        const product = variant.product;

        const points = product.points ? parseInt(product.points.value) : 0;
        const productPoints = product.productPoints
          ? parseInt(product.productPoints.value)
          : variant.points
          ? parseInt(variant.points.value)
          : 0;
        const image = variant.image ? variant.image.url : "";

        const patchSide =
          product.productType === "Patch"
            ? {
                width: JSON.parse(product.width.value).value,
                height: JSON.parse(product.height.value).value,
              }
            : {};

        return {
          productId: product.id,
          variantId: variant.id,
          productTitle: product.title,
          variantTitle: variant.title,
          productType: product.productType,
          price: parseInt(variant.price.amount),
          quantity: e.node.quantity,
          customAttributes: e.node.attributes || [],
          points,
          productPoints,
          image,
          ...patchSide,
        };
      }),
    };
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetCartById;
